module.exports = __webpack_public_path__ + "b3f7c546e6f3f2f87d7db285bfc6cf6f.pdf";